// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CRMRevopsArchitectRouteImport } from './routes/CRM-revops-architect'
import { Route as AboutRouteImport } from './routes/about'
import { Route as BookRouteImport } from './routes/book'
import { Route as CloseCrmAutomationSpecialistRouteImport } from './routes/close-crm-automation-specialist'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GhlAutomationExpertAustraliaRouteImport } from './routes/ghl-automation-expert-australia'
import { Route as GohighlevelRevopsArchitectRouteImport } from './routes/gohighlevel-revops-architect'
import { Route as GoogleAdsPerformanceSpecialistRouteImport } from './routes/google-ads-performance-specialist'
import { Route as HireTechnicalVaUsaRouteImport } from './routes/hire-technical-va-usa'
import { Route as HubspotRevopsArchitectRouteImport } from './routes/hubspot-revops-architect'
import { Route as MetaAdsPerformanceSpecialistRouteImport } from './routes/meta-ads-performance-specialist'
import { Route as N8nWorkflowDeveloperRouteImport } from './routes/n8n-workflow-developer'
import { Route as RevopsSpecialistUkRouteImport } from './routes/revops-specialist-uk'
import { Route as SeoGeoArchitectRouteImport } from './routes/seo-geo-architect'
import { Route as VoiceAiVapiAutomationRouteImport } from './routes/voice-ai-vapi-automation'
import { Route as ZapierMakeAutomationExpertRouteImport } from './routes/zapier-make-automation-expert'
import { Route as AuthorsSlugRouteImport } from './routes/authors/$slug'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as BlogCategoryCategorySlugRouteImport } from './routes/blog/category/$categorySlug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CRMRevopsArchitectRoute = CRMRevopsArchitectRouteImport.update({
            id: '/CRM-revops-architect',path: '/CRM-revops-architect',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const CloseCrmAutomationSpecialistRoute = CloseCrmAutomationSpecialistRouteImport.update({
            id: '/close-crm-automation-specialist',path: '/close-crm-automation-specialist',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const GhlAutomationExpertAustraliaRoute = GhlAutomationExpertAustraliaRouteImport.update({
            id: '/ghl-automation-expert-australia',path: '/ghl-automation-expert-australia',getParentRoute: () => rootRouteImport
          })
const GohighlevelRevopsArchitectRoute = GohighlevelRevopsArchitectRouteImport.update({
            id: '/gohighlevel-revops-architect',path: '/gohighlevel-revops-architect',getParentRoute: () => rootRouteImport
          })
const GoogleAdsPerformanceSpecialistRoute = GoogleAdsPerformanceSpecialistRouteImport.update({
            id: '/google-ads-performance-specialist',path: '/google-ads-performance-specialist',getParentRoute: () => rootRouteImport
          })
const HireTechnicalVaUsaRoute = HireTechnicalVaUsaRouteImport.update({
            id: '/hire-technical-va-usa',path: '/hire-technical-va-usa',getParentRoute: () => rootRouteImport
          })
const HubspotRevopsArchitectRoute = HubspotRevopsArchitectRouteImport.update({
            id: '/hubspot-revops-architect',path: '/hubspot-revops-architect',getParentRoute: () => rootRouteImport
          })
const MetaAdsPerformanceSpecialistRoute = MetaAdsPerformanceSpecialistRouteImport.update({
            id: '/meta-ads-performance-specialist',path: '/meta-ads-performance-specialist',getParentRoute: () => rootRouteImport
          })
const N8nWorkflowDeveloperRoute = N8nWorkflowDeveloperRouteImport.update({
            id: '/n8n-workflow-developer',path: '/n8n-workflow-developer',getParentRoute: () => rootRouteImport
          })
const RevopsSpecialistUkRoute = RevopsSpecialistUkRouteImport.update({
            id: '/revops-specialist-uk',path: '/revops-specialist-uk',getParentRoute: () => rootRouteImport
          })
const SeoGeoArchitectRoute = SeoGeoArchitectRouteImport.update({
            id: '/seo-geo-architect',path: '/seo-geo-architect',getParentRoute: () => rootRouteImport
          })
const VoiceAiVapiAutomationRoute = VoiceAiVapiAutomationRouteImport.update({
            id: '/voice-ai-vapi-automation',path: '/voice-ai-vapi-automation',getParentRoute: () => rootRouteImport
          })
const ZapierMakeAutomationExpertRoute = ZapierMakeAutomationExpertRouteImport.update({
            id: '/zapier-make-automation-expert',path: '/zapier-make-automation-expert',getParentRoute: () => rootRouteImport
          })
const AuthorsSlugRoute = AuthorsSlugRouteImport.update({
            id: '/authors/$slug',path: '/authors/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BlogCategoryCategorySlugRoute = BlogCategoryCategorySlugRouteImport.update({
            id: '/blog/category/$categorySlug',path: '/blog/category/$categorySlug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,CRMRevopsArchitectRoute: CRMRevopsArchitectRoute,AboutRoute: AboutRoute,BookRoute: BookRoute,CloseCrmAutomationSpecialistRoute: CloseCrmAutomationSpecialistRoute,ContactRoute: ContactRoute,GhlAutomationExpertAustraliaRoute: GhlAutomationExpertAustraliaRoute,GohighlevelRevopsArchitectRoute: GohighlevelRevopsArchitectRoute,GoogleAdsPerformanceSpecialistRoute: GoogleAdsPerformanceSpecialistRoute,HireTechnicalVaUsaRoute: HireTechnicalVaUsaRoute,HubspotRevopsArchitectRoute: HubspotRevopsArchitectRoute,MetaAdsPerformanceSpecialistRoute: MetaAdsPerformanceSpecialistRoute,N8nWorkflowDeveloperRoute: N8nWorkflowDeveloperRoute,RevopsSpecialistUkRoute: RevopsSpecialistUkRoute,SeoGeoArchitectRoute: SeoGeoArchitectRoute,VoiceAiVapiAutomationRoute: VoiceAiVapiAutomationRoute,ZapierMakeAutomationExpertRoute: ZapierMakeAutomationExpertRoute,AuthorsSlugRoute: AuthorsSlugRoute,BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogCategoryCategorySlugRoute: BlogCategoryCategorySlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)